import ReviewBox from './src/main'

export default ReviewBox



// WEBPACK FOOTER //
// ./src/views/question-review/components/ReviewBox/index.js